import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import * as actions from '../../../../actions/productData';
import { addToCart as addProductToCart } from '../../../../actions/addProductToCart';
import { generateEvent } from '../../../../utils/dataGrinch';
import cleverTapPushEvent from '../../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../../modules/ajio-util/cleverTap/eventConstants';

import { getLuxeFlags } from '../../../../Flags/selectors';
import { getCurrentStore } from '../../../../refresh/selectors/metaData';
import { gtmEventPush, gtmAddToCart, luxeGtmAddToCart } from '../../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../../refresh/constants/luxeScreenType';
import { setProductStoreMappingData } from '../../../../refresh/utils/productStoreMappingUtils';
import { signInCheck } from '../../CheckUserStatus';
import { readCookie } from '../../Cookie';
import { jioAdsAddtoCart } from '../../../../utils/jioAds';
import { getTagValueFromTagEngine, getPriceLableFromTagEngine } from '../../../../utils/product';
import _get from 'lodash/get';

const { plp: { screenType = '', screenName = '' } = {}, luxeStore, defaultStore } = luxeScreen;
class AddToCart extends React.Component {
  getSizeOptions = () => {
    const { data } = this.props;
    const { baseOptions = [], variantOptions = [] } = data || {};
    const sizeVariant = baseOptions.find(item => item && item.variantType === 'FnlSizeVariant');
    return (sizeVariant ? sizeVariant.options : variantOptions) || [];
  };

  getSelectedSizeCode = () => {
    const { selectedSizeCode = '' } = this.props;
    if (selectedSizeCode) {
      return selectedSizeCode;
    }
    const options = this.getSizeOptions();
    return options.length === 1 ? options[0].code || '' : '';
  };

  addToCart = debounce(
    () => {
      const selectedSizeCode = this.getSelectedSizeCode();
      if (selectedSizeCode) {
        const { newDesignLuxe } = this.props;
        let {
          data: {
            price: { formattedValue: Price = '', value: spPrice = 0 } = {},
            baseProduct = '',
            code = '',
            baseOptions = [],
            variantOptions = [],
            name = '',
            fnlColorVariantData = {},
            brickName,
            brickCategory,
            brickSubCategory,
            commercialType = '',
            catalog = ''
          }
        } = this.props;

        let variants = baseOptions.reduce((accumlator, item) => {
          let { variantType = '' } = item;
          if (variantType === 'FnlSizeVariant') {
            accumlator = item.options || [];
          }
          return accumlator;
        }, []);

        if (variants.length == 0 && variantOptions.length) {
          variants = variantOptions;
        }

        let sizeObj = variants.reduce((accumlator, item) => {
          let { code = '' } = item;
          if (code === selectedSizeCode) {
            accumlator = item;
          }
          return accumlator;
        }, {});

        let {
          wasPriceData: { value: mp = 0, formattedValue: formattedMp = '' } = {},
          priceData: { value: sp = 0, formattedValue: formattedSp = '' } = {}
        } = sizeObj;

        let userLogin = signInCheck();
        if (userLogin) {
          const itemCode = baseProduct.split('_')[0] || '';
          const userId = decodeURIComponent(readCookie('CI')) || '';
          setProductStoreMappingData(userId, itemCode, newDesignLuxe ? 'luxe' : defaultStore);
        }

        if (newDesignLuxe) {
          gtmEventPush({
            event: 'plp_add_to_cart',
            event_category: 'quick_view_interactions',
            event_action: 'add to cart',
            event_label: selectedSizeCode,
            store_type: 'luxe',
            screen_name: screenName,
            screen_type: screenType
          });
        } else {
          generateEvent({
            Event: 'AddToBag',
            value: {
              SizeSelected: selectedSizeCode,
              Quantity: 1,
              Price: formattedSp,
              OriginalPrice: formattedMp,
              ProductId: baseProduct,
              ProductId: baseProduct,
              Discount: `${Math.round(((mp - sp) / mp) * 100)}%`
            }
          });
          console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
          const addToCartObj = {
            brickCategory,
            brickSubCategory,
            brickName,
            code,
            price: spPrice,
            quantity: 1
          };
          jioAdsAddtoCart(addToCartObj);
        }
        this.handleGtmEvents();

        cleverTapPushEvent({
          eventName: CLEVERTAP_EVENT_NAMES.Added_to_Closet,
          eventObj: {
            Name: name,
            Brand: fnlColorVariantData.brandName,
            Brick: brickName,
            Price,
            ProductId: baseProduct,
            Category: brickCategory,
            Vertical: brickSubCategory
          }
        });
        let batchId = '';
        if (_get(variantOptions, 'length') > 0) {
          const sizeVariantOptionsArr = variantOptions?.filter(
            variant => variant?.code === selectedSizeCode || variant?.code === code
          );
          const variantOptionQualifiers = _get(sizeVariantOptionsArr, '[0].variantOptionQualifiers');
          variantOptionQualifiers?.forEach(variant => {
            if (variant.qualifier === 'imsBatchId') {
              batchId = variant.value;
            }
          });
        }
        console.log("TRACK BATCH ID ~ batchId:", batchId)
        console.log("TRACK COMMERICAL TYPE ~ commercialType:", commercialType);
        if(batchId || commercialType){
          this.props.addProductToCart(selectedSizeCode, 'desktop', '', '', batchId, commercialType);
        } else {
          this.props.addProductToCart(selectedSizeCode, 'desktop');
        }
      } else {
        this.props.selectSizeErrorQuickview('Please select a size');
      }
    },
    3000,
    { leading: true, trailing: false }
  );

  handleGtmEvents = () => {
    const {
      data: {
        baseProduct: productCode = '',
        code,
        brickCategory = '',
        brickName = '',
        fnlColorVariantData: {
          color: productColor = '',
          productTag = '',
          brandName = '',
          exclusiveTill = ''
        } = {},
        price: { value, discountPercent, segmentId = '', experimentId = '' } = {},
        wasPriceData: { value: price = '' } = {},
        name,
        tagResponse: { tag: { categoryTags = [] } = {} } = {},
        brickSubCategory = '',
        catalog
      } = {},
      selectedSizeName,
      newDesignLuxe,
      currentStore,
      averageRating,
      numUserRatings
    } = this.props;
    const selectedSizeCode = this.getSelectedSizeCode();

    const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
    const productPriceLabel = getPriceLableFromTagEngine(categoryTags);

    const tag = exclusiveTill ? 'Exclusive' : productTag;
    if (newDesignLuxe) {
      luxeGtmAddToCart(
        name,
        code?.split('_')[0],
        value,
        brandName,
        brickCategory,
        selectedSizeName,
        code?.split('_')[1],
        discountPercent,
        brickName,
        tag,
        1,
        screenName,
        luxeStore,
        screenType,
        'Quick View Product Details',
        screenName,
        luxeStore,
        true,
        '',
        segmentId,
        experimentId,
        price,
        '',
        '',
        '',
        '',
        selectedSizeCode
      );
    } else {
      let variant = code?.split('_')[1] || '';

      gtmAddToCart(
        code?.split('_')[0],
        name,
        value,
        brandName,
        brickName,
        brickCategory,
        brickSubCategory,
        variant,
        '1',
        discountPercent,
        selectedSizeName,
        currentStore ? currentStore : 'Ajio',
        'quick view',
        code,
        productTagEngineValue,
        productPriceLabel,
        averageRating,
        numUserRatings,
        catalog,
        segmentId,
        experimentId,
        'Quick View Product Details',
        price,
        value,
        '',
        '',
        selectedSizeCode
      );
    }
  };

  render() {
    const prodData = this.props.productData;
    const { oosStatus = [], newDesignLuxe } = this.props;
    const selectedSizeCode = this.getSelectedSizeCode();
    if (selectedSizeCode && oosStatus.includes(selectedSizeCode)) {
      return (
        <div className="product-oos-block">
          <div className="oos-item-unavailable">
            You just missed it. This size is currently out of stock.
          </div>
          <div className="oos-heading">
            <span className="ic-pdp-oos" />
            &nbsp;OUT OF STOCK!
          </div>
        </div>
      );
    }

    return (
      <div className={newDesignLuxe ? 'pdp-cart' : null}>
        <div className="pdp-addtocart-button">
          <div className="pdp-border">
            <div
              className={newDesignLuxe ? 'btn-gold btn-dark' : 'btn-gold'}
              onClick={() => this.addToCart()}
              role="button"
              tabIndex={0}
            >
              <span className="ic-pdp-add-cart" />
              <span aria-label={newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}>{newDesignLuxe ? 'ADD TO CART' : 'ADD TO BAG'}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { flags } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    selectedSizeCode: state.popup.selectedSizeCode,
    selectedSizeName: state.popup.selectedSizeName,
    oosStatus: state.cart.oosStatus,
    newDesignLuxe
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addProductToCart: (...args) => dispatch(addProductToCart(...args)),
    selectSizeErrorQuickview: message => dispatch(actions.selectSizeErrorQuickview(message))
  };
};

export default AddToCart = connect(mapStateToProps, mapDispatchToProps)(AddToCart);
